module.exports = __webpack_public_path__ + "img/logo.480b3cbd.png";